<template>
  <div id="side-cart" class="side-cart" :class="{ open: openCartSidebar }">
    <a href="#" class="overlay" @click="closeCartSidebar()"></a>
    <div class="side-cart-content">
      <a
        href="javascript:void(0)"
        class="btn btn-outline cart-close"
        @click="closeCartSidebar()"
      >
        <!-- <img src="/images/svg/global/close.svg" class="img-fluid" alt="close" /> -->
        <svg width="18" height="18" class="default-color" fill="none">
          <use xlink:href="#closeIcon" />
        </svg>
        {{ _T('Close') }}
      </a>
      <div class="side-cart-title">
        <h4>
          {{ _T('Your trolly') }}
          <span>({{ cart_items_count }} {{ _T('items') }})</span>
        </h4>
      </div>
      <Top v-if="!domainBasedBrand"></Top>
      <div class="side-cart-detail" v-if="cart_items_count">
        <Items
          v-for="item in cart_items"
          :item="item"
          :key="'cart-slider' + item.index"
        ></Items>
      </div>
      <empty-cart v-else></empty-cart>
      <Bottom></Bottom>
      <!-- <mobile-checkout></mobile-checkout> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Top from './Cart/Top'
import Items from './Cart/Item'
import Bottom from './Cart/Bottom'
import EmptyCart from '../Blocks/Cart/EmptyCart'
export default {
  props: ['openCart'],
  components: {
    Top,
    Items,
    Bottom,
    EmptyCart,
  },
  methods: {
    closeCartSidebar() {
      this.$store.commit('OPEN_CART_SIDEBAR')
      document.body.classList.remove('body-overlay')
    },
  },
  computed: {
    ...mapGetters(['cart_items', 'cart_items_count', '_T', 'domainBasedBrand']),
    ...mapState({
      openCartSidebar: state => state.cart_store.openCartSidebar,
    }),
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .side-cart {
    .cart-close {
      left: 1.25rem;
      right: unset;
    }
  }
  .side-cart {
    .side-cart-content {
      text-align: right;
    }
  }
}
.side-cart {
  position: fixed;
  background-color: $white;
  width: 36.25rem;
  right: -36.25rem;
  top: 0;
  height: 100vh;
  transition: all 0.5s ease;
  z-index: 9;
  .overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(var(--color-font-color-source), 0.8);
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    transition: all 0.5s ease;
  }
  .side-cart-content {
    background-color: $white;
    height: 100%;
  }
  .cart-close {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    &:hover {
      background-color: $white;
      color: $color-primary;
    }
  }
  .side-cart-title {
    padding: 1.875rem;
    border-bottom: 1px solid $light-border;
    h4 {
      color: $font-color;
      line-height: 1.375rem;
      letter-spacing: 0.02em;
      text-transform: capitalize;
      font-weight: 600;
      margin-bottom: 0;
      span {
        text-transform: lowercase;
        font-weight: 400;
        color: $light-font;
      }
    }
  }
  &.open {
    right: 0;
    transition: all 0.5s ease;
    .overlay {
      opacity: 1;
      visibility: visible;
      transition: all 0.5s ease;
    }
  }
  .side-cart-detail {
    padding: 0.625rem 1.875rem 0;
    height: calc(100vh - #{$px330});
    overflow: hidden;
    overflow-y: auto;
    //   &::-webkit-scrollbar {
    //     display: none;
    //   }
    &::-webkit-scrollbar {
      width: $px10;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: $scrollbar-track;
      border-radius: $px6;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb;
      border-radius: $px4;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: darken($scrollbar-track, 0.2);
    }
  }
}
.default-color {
  stroke: $color-primary;
}
</style>
